'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _table = require('../basic/table');

var _table2 = _interopRequireDefault(_table);

var _pagination = require('../basic/pagination');

var _pagination2 = _interopRequireDefault(_pagination);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function noop() {}

var Table = _react2["default"].createClass({
	displayName: 'Table',

	getDefaultProps: function getDefaultProps() {
		return {
			id: "table_default_id",
			title: [],
			jsonKey: [],
			data: null,
			doList: noop,
			pageSize: 0,
			pageNo: 1,
			totalRows: 0,
			checkType: "none",
			turnable: true
		};
	},
	getInitialState: function getInitialState() {
		return {
			pageNo: this.props.pageNo,
			pageSize: this.props.pageSize,
			columns: []
		};
	},
	componentDidMount: function componentDidMount() {
		this.formatCol(this.props.title, this.props.jsonKey, this.props.data);
	},
	formatCol: function formatCol(title, jsonKey, data) {
		if (title.length != jsonKey.length) {
			console.info('注意! ' + this.props.id + '的title和jsonKey数量对不上.');
		}
		var columns = [];
		for (var i = 0; i < title.length; i++) {
			columns.push({
				key: i,
				title: title[i],
				dataIndex: jsonKey[i]
			});
			if (this.props.filters && this.props.filters[i] != undefined) {
				columns[i]["filters"] = this.props.filters[i];
			}
			if (this.props.onFilter && this.props.onFilter[i] != undefined) {
				columns[i]["onFilter"] = this.props.onFilter[i];
			}
			if (this.props.sorter && this.props.sorter[i] != undefined) {
				columns[i]["sorter"] = this.props.sorter[i];
			}
			if (this.props.filterMultiple && this.props.filterMultiple[i] != undefined) {
				columns[i]["filterMultiple"] = this.props.filterMultiple[i];
			}
		}
		for (var i = 0; i < data.length; i++) {
			if (!data[i]["key"]) data[i]["key"] = i.toString();
		}
		this.setState({ columns: columns });
	},
	onChange: function onChange(pageNo) {
		this.props.doList(pageNo, this.state.pageSize);
		this.setState({ pageNo: pageNo });
	},
	componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
		//如果传入了新的title或者jsonKey, 则重构columns
		if (this.props.title != nextProps.title || this.props.jsonKey != nextProps.jsonKey) {
			this.formatCol(nextProps.title, nextProps.jsonKey, nextProps.data);
		}
		if (this.props.pageNo != nextProps.pageNo) {
			this.setState({ pageNo: nextProps.pageNo });
		}
	},

	onShowSizeChange: function onShowSizeChange(pageNo, pageSize) {
		this.props.doList(pageNo, pageSize);
		this.setState({
			pageNo: pageNo,
			pageSize: pageSize
		});
	},
	render: function render() {
		return _react2["default"].createElement(
			'div',
			{ style: { padding: 15 } },
			_react2["default"].createElement(
				'div',
				{ className: 'row' },
				_react2["default"].createElement(_table2["default"], {
					bordered: true,
					rowSelection: this.props.rowSelection,
					loading: this.state.isLoading,
					columns: this.state.columns,
					dataSource: this.props.data,
					pagination: false,
					size: this.props.size,
					expandedRowRender: this.props.expandedRowRender,
					onRowClick: this.props.onRowClick,
					columnsPageRange: this.props.columnsPageRange,
					columnsPageSize: this.props.columnsPageSize })
			),
			this.props.turnable ? _react2["default"].createElement(
				'div',
				{ className: 'row', style: { "marginTop": "5px" } },
				_react2["default"].createElement(_pagination2["default"], { style: { "float": "right" },
					showSizeChanger: true,
					showQuickJumper: true,
					current: this.state.pageNo,
					pageSize: this.state.pageSize,
					onChange: this.onChange,
					onShowSizeChange: this.onShowSizeChange,
					defaultCurrent: this.state.pageNo,
					total: this.props.totalRows })
			) : null
		);
	}
});

exports["default"] = Table;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./components/business/table.jsx
 ** module id = 620
 ** module chunks = 0
 **/